import React, { useState, useEffect } from "react"
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './about.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
// -------------------------------------------------

/**
 * About Component
 * Displays company information with:
 * - Hero section with gradient background
 * - Value proposition cards with icons
 * - Company stats section
 * - Mission and vision sections
 */
const About = () => {

  // Feature cards data - shows key value propositions of the company
  const features = [
    {
      icon: 'fa-solid fa-globe',
      title: 'Expert Planning',
      description: 'Our experienced team offers tailored itineraries to match your unique preferences, ensuring every detail is perfect.',
      color: '#5143d9'
    },
    {
      icon: 'fa-solid fa-clock',
      title: 'Time & Cost Savings',
      description: 'We handle all logistics, saving you time and securing the best deals through our industry connections.',
      color: '#10b981'
    },
    {
      icon: 'fa-solid fa-shield-halved',
      title: 'Safety First',
      description: 'Your safety is our priority. We provide 24/7 support and stay updated on travel advisories.',
      color: '#f59e0b'
    },
    {
      icon: 'fa-solid fa-star',
      title: 'Exclusive Experiences',
      description: 'Access hidden gems and unique experiences with our extensive local connections.',
      color: '#ef4444'
    }
  ];

  // Company statistics for visual impact
  const stats = [
    { number: '500+', label: 'Happy Travelers', icon: 'fa-solid fa-users' },
    { number: '50+', label: 'Destinations', icon: 'fa-solid fa-map-location-dot' },
    { number: '24/7', label: 'Support', icon: 'fa-solid fa-headset' },
    { number: '100%', label: 'Satisfaction', icon: 'fa-solid fa-heart' }
  ];

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className='about-hero'>
        <div className='about-hero-overlay'></div>
        <div className='container about-hero-content'>
          <h1>About Travel Pradesh</h1>
          <p>Your Trusted Partner for Unforgettable Journeys</p>
        </div>
      </section>

      {/* Stats Section */}
      <section className='about-stats'>
        <div className='container'>
          <div className='row'>
            {stats.map((stat, index) => (
              <div key={index} className='col-6 col-md-3'>
                <div className='stat-card'>
                  <div className='stat-icon'>
                    <i className={stat.icon}></i>
                  </div>
                  <h3>{stat.number}</h3>
                  <p>{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className='about-content py-5'>
        <div className='container'>
          <div className='row align-items-center mb-5'>
            <div className='col-md-6'>
              <div className='about-image-wrapper'>
                <img src='/images/about-travel.jpg' alt='Travel Pradesh' onError={(e) => { e.target.src = '../images/aboutico.webp'; }} />
                <div className='about-image-badge'>
                  <i className='fa-solid fa-award'></i>
                  <span>Trusted Since 2020</span>
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='about-text'>
                <span className='about-label'>Who We Are</span>
                <h2>Your Dedicated Travel Partner</h2>
                <p>
                  TRAVEL PRADESH offers a top-notch request-based online platform for all your travel needs,
                  specializing in holiday packages, hotel bookings, flights, trains, buses, cabs, and visa assistance.
                </p>
                <p>
                  Our main focus is on providing tailored travel solutions for the corporate sector, ensuring
                  seamless and efficient travel planning for business trips, corporate events, and personalized holidays.
                </p>
                <p>
                  Our user-friendly platform allows for easy and fast ticket bookings and travel itinerary management,
                  offering flexibility and convenience. With a commitment to excellence, Travel Pradesh delivers
                  customized tickets and travel plans that perfectly align with your schedule and preferences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className='about-features'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <span className='section-label'>Why Choose Us</span>
            <h2>What Makes Us Different</h2>
          </div>
          <div className='row'>
            {features.map((feature, index) => (
              <div key={index} className='col-md-6 col-lg-3 mb-4'>
                <div className='feature-card'>
                  <div className='feature-icon' style={{ backgroundColor: `${feature.color}15`, color: feature.color }}>
                    <i className={feature.icon}></i>
                  </div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className='about-mission py-5'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-6 order-md-2'>
              <div className='mission-image'>
                <img src='../images/mission-travel.jpg' alt='Our Mission' onError={(e) => { e.target.src = '../images/tourBg.jpg'; }} />
              </div>
            </div>
            <div className='col-md-6 order-md-1'>
              <div className='mission-text'>
                <span className='about-label'>Our Mission</span>
                <h2>Turning Travel Aspirations Into Reality</h2>
                <p>
                  Travel Pradesh goes beyond being just a travel booking site; it serves as your dedicated travel partner.
                  We recognize that each trip holds its own significance, which is why we customize our offerings to align
                  with your individual preferences.
                </p>
                <p>
                  As soon as you reach out through our website, phone, or email, our devoted team will connect with you to
                  ensure a seamless and enjoyable travel experience. Whether you're planning a business trip or a family getaway,
                  we meticulously handle every aspect, providing tailored solutions and round-the-clock support.
                </p>
                <div className='mission-cta'>
                  <a href='/contact' className='btn-primary-custom'>
                    <i className='fa-solid fa-paper-plane me-2'></i>
                    Get In Touch
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default About

